import React, { Component } from 'react';
import { base } from '../../base';
import OrderListView from '../views/OrderListView';

class OrderListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: []
        };
    }

    componentDidMount() {
        this.refData = base.syncState('orders', {
            context: this,
            asArray: true,
            state: 'orders',
        })
    }

    componentWillUnmount() {
        base.removeBinding(this.refData);
    }

    render() {
        return <OrderListView orders={this.state.orders} />;
    }
}

export default OrderListContainer;



// WEBPACK FOOTER //
// ./src/components/containers/OrderListContainer.jsx